module.exports = __webpack_public_path__ + "img/rzy.19350a07.png";